import { render } from "./ComplianceImpersonate.vue?vue&type=template&id=072ba6b3&scoped=true"
import script from "./ComplianceImpersonate.vue?vue&type=script&lang=js"
export * from "./ComplianceImpersonate.vue?vue&type=script&lang=js"

import "./ComplianceImpersonate.vue?vue&type=style&index=0&id=072ba6b3&lang=scss"
import "./ComplianceImpersonate.vue?vue&type=style&index=1&id=072ba6b3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072ba6b3"]])

export default __exports__